import { render, staticRenderFns } from "./sideAdvertisingSpace.vue?vue&type=template&id=5ad69ca1&scoped=true"
import script from "./sideAdvertisingSpace.vue?vue&type=script&lang=js"
export * from "./sideAdvertisingSpace.vue?vue&type=script&lang=js"
import style0 from "./sideAdvertisingSpace.vue?vue&type=style&index=0&id=5ad69ca1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad69ca1",
  null
  
)

export default component.exports